<template>
	<div class="time-bar"
		:style="barStyles"
		:class="{ rotated: currentStageSettings.rotate_timebar }"
	>
		<i class="progress"
			:class="{ inactive: !activeCycle }"
			:style="progressStyle"
		></i>
		<span class="time-unit" v-html="cycleTextHTML"></span>
		<span class="time-unit-elapsed">{{ currentGameCycle }}</span>
	</div>
</template>

<script>
import scrambleText from '@/mixins/scramble-text';
import { elementsToStrings } from '@/mixins/text-wrapper';
import { mapState, mapGetters } from 'vuex';

export default {
	name: 'TimeBar',
	mixins: [scrambleText],
	computed: {
		...mapState({
			cycleName: state => state.config.general.unit_of_time,
			activeCycle: state => state.cycle.active,
			currentGameCycle: state => state.cycle.completedGameCycles + 1,
			paused: state => state.timer.paused,
			duration: state => state.config.general.refresh_interval,
		}),
		...mapGetters([
			"cyclePercentageRemaining",
			"currentStageSettings",
		]),
		barStyles() {
			const styles = {};

			if (this.currentStageSettings.timebar_colors) {
				if ("background" in this.currentStageSettings.timebar_colors) {
					styles.backgroundColor = this.currentStageSettings.timebar_colors.background;
				}
				if ("text" in this.currentStageSettings.timebar_colors) {
					styles.color = this.currentStageSettings.timebar_colors.text;
				}
				if ("border" in this.currentStageSettings.timebar_colors) {
					styles.borderColor = this.currentStageSettings.timebar_colors.border;
				}
			}

			return styles;
		},
		progressStyle() {
			const styles = {};

			if (!this.paused && this.activeCycle) {
				styles.transitionDuration = `${this.cyclePercentageRemaining * this.duration}s`;
			}

			if (this.currentStageSettings.timebar_colors && "foreground" in this.currentStageSettings.timebar_colors) {
				styles.backgroundColor = this.currentStageSettings.timebar_colors.foreground;
			}

			if (this.paused) {
				styles.width = `${this.percentageRemaining}%`;
			}

			return styles;
		},
		percentageRemaining() {
			return this.cyclePercentageRemaining * 100 || 100;
		},
		cycleTextHTML() {
			let html = this.cycleName;

			if (this.currentStageSettings.scramble_text) {
				const letters = this.buildLetterArray(html);
				this.scrambleText(letters);
				html = elementsToStrings(letters);
			}

			return html;
		},
	},
};
</script>

<style lang="scss" scoped>
	.time-bar {
		display: flex;
		width: 100%;
		height: 2em;
		padding: 0 1em;
		align-items: center;
		justify-content: flex-start;

		position: relative;

		text-transform: uppercase;
		font-weight: 700;
		letter-spacing: 0.07em;

		backface-visibility: hidden;
		background-image: url($line-pattern);
		background-color: $brand-color-primary-light;
		border: 1px solid $gray-light;
		color: #ffffff;
		background-position: 0 0;
		transform-origin: top left;

		&.rotated {
			backface-visibility: hidden;
			transform: rotate3d(0, 0, 1, 2.5deg);
		}

		.progress {
			display: block;
			height: 100%;
			width: 0;
			position: absolute;
			left: 0;
			top: 0;
			bottom: 0;
			background: $brand-color-primary-dark;

			transition-property: width;
			transition-timing-function: linear;

			&.inactive {
				width: 100%;
				transition: width $ui-transition-duration;
				transition-timing-function: linear;
			}
		}

		* {
			position: relative;
			z-index: 10;
		}
	}

	.time-unit-elapsed {
		margin-left: .5em;
	}
</style>



// WEBPACK FOOTER //
// src/components/board/TimeBar.vue